module.exports = __webpack_public_path__ + "img/notice.c75c2761.png";